import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import job from "../assets/images/job.webp";
import career from "../assets/images/career.webp";
import hero from "../assets/images/hero-career.webp";
import career1 from "../assets/images/job1.webp";
import career2 from "../assets/images/job2.webp";
import career3 from "../assets/images/job3.webp";
import career4 from "../assets/images/job4.webp";
import career5 from "../assets/images/job5.webp";
import career6 from "../assets/images/job6.webp";

import job1 from "../assets/images/digital.svg";
import job2 from "../assets/images/progress.svg";
import job3 from "../assets/images/calture.svg";
import job4 from "../assets/images/growth.svg";
import CareerPopUp from "../components/CareerPopUp";

const valuesData = [
  {
    title: "A Culture of Trust",
    description:
      "Our foundation is built on a century of ethical practices. We believe in building trust with our customers and our employees through clear communication and complete transparency.",
    image: job3,
  },
  {
    title: "Passion for Progress",
    description:
      "We are a team driven by a passion for the automotive and construction industries. Our deep domain expertise allows us to create innovative solutions that truly make a difference.",
    image: job2,
  },
  {
    title: "Digital-First Innovation",
    description:
      "We're at the forefront of the digital revolution in finance. Join a team that is not afraid to challenge the status quo and lead the way in creating seamless, tech-driven financial services.",
    image: job1,
  },
  {
    title: "Growth and Empowerment",
    description:
      "We offer an environment where every employee is encouraged to take ownership. We provide the tools and support you need to enhance your skills and grow alongside the company.",
    image: job4,
  },
];

const offersData = [
  {
    title: "Job Security",
    image: career1,
  },
  {
    title: "Performance Bonus",
    image: career2,
  },
  {
    title: "Medical Insurance",
    image: career3,
  },
  {
    title: "Attractive Salary",
    image: career4,
  },
  {
    title: "Put Family First",
    image: career5,
  },
  {
    title: "Learning & Development",
    image: career6,
  },
];

const CareersPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <Box sx={{ backgroundColor: "#EBF8FF" }}>
        <Container maxWidth="lg">
          <Stack
            direction={{ xs: "column", md: "row" }}
            alignItems="center"
            spacing={5}
            sx={{ py: 8 }}
          >
            {/* Left Text Section */}
            <Box
              sx={{
                width: { xs: "100%", md: "60%" },
                textAlign: { xs: "center", md: "left" },
              }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: "2rem", md: "3rem" },
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 600,
                  color: "#0265fe",
                  mb: 2,
                }}
              >
                Join Our Team & Bring
                <br />
                <span style={{ color: "#000" }}>Your Dreams to Reality.</span>
              </Typography>

              <Typography
                variant="h6"
                sx={{
                  fontSize: { xs: "1rem", md: "1.2rem" },
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  color: "#000",
                  lineHeight: 1.6,
                  mt: 1,
                }}
              >
                Join us to experience PSN Finance revolution happening in India
                & shape to your ideas and execution capabilities.
              </Typography>

              <Button
                variant="contained"
                onClick={handleOpen}
                sx={{
                  backgroundColor: "#00cc87",
                  color: "white",
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "14px",
                  px: 3,
                  py: 0.5,
                  mt: 3,
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "#0265fe",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                Apply Now
              </Button>
            </Box>

            {/* Right Image Section */}
            <Box
              component="img"
              src={hero}
              alt="Career Opportunities"
              sx={{
                width: { xs: "100%", md: "40%" },
                borderRadius: 2,
                mt: { xs: 4, md: 0 },
              }}
            />
          </Stack>
        </Container>
      </Box>

      <Box sx={{ backgroundColor: "#fff", py: 8 }}>
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            align="center"
            fontFamily="Inter, sans-serif"
            sx={{
              fontWeight: "bold",
              fontSize: isMobile ? "1.8rem" : "2.5rem",
              lineHeight: isMobile ? "2.2rem" : "3.5rem",
              mb: 5,
              pt: isMobile ? 3 : 0,
            }}
          >
            <Box
              component="span"
              sx={{ color: "#0265fe", fontFamily: "Inter, sans-serif" }}
            >
              Your Career
            </Box>
            {"  "}
            at PSN Finance
          </Typography>
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={4}
            justifyContent="center"
            alignItems="stretch"
          >
            {valuesData.map((item, index) => (
              <Card
                key={index}
                sx={{
                  flex: 1,
                  textAlign: "center",
                  borderRadius: 3,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                  transition: "transform 0.3s",
                  "&:hover": { transform: "translateY(-5px)" },
                }}
              >
                <Box
                  component="img"
                  src={item.image}
                  alt={item.title}
                  sx={{
                    width: "50%",
                    height: "auto",
                    objectFit: "contain",
                    p: 2,
                    mt: 2,
                  }}
                />
                <CardContent sx={{ mt: { xs: 0, md: -3 } }}>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 600, mb: 1, color: "#111" }}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "text.secondary",
                      lineHeight: 1.6,
                      textAlign: "justify",
                    }}
                  >
                    {item.description}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Stack>
        </Container>
      </Box>

      <Box sx={{ py: 3, backgroundColor: "#fff" }}>
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            align="center"
            fontFamily="Inter, sans-serif"
            sx={{
              fontWeight: "bold",
              fontSize: isMobile ? "1.8rem" : "2.5rem",
              lineHeight: isMobile ? "2.2rem" : "3.5rem",
              mb: 5,
              pt: isMobile ? 3 : 0,
            }}
          >
            What We
            <Box
              component="span"
              sx={{ color: "#0265fe", fontFamily: "Inter, sans-serif" }}
            >
              {"  "}Offer
            </Box>
          </Typography>
          <Typography
            variant="body2"
            align="center"
            sx={{
              fontSize: "1.2rem",
              lineHeight: 1.6,
              color: "text.secondary",
              mb: 6,
            }}
          >
            Our core values are the heart of our business and the foundation of
            our relationships. They guide our actions, ensuring we remain
            ethical, empathetic, and responsible in every interaction.
          </Typography>

          {/* 2 rows with 3 items each */}
          <Stack spacing={4} sx={{ width: "100%" }}>
            <Stack
              direction="row"
              justifyContent="center"
              sx={{ width: "100%", flexWrap: "wrap" }}
              spacing={2}
            >
              {offersData.slice(0, 3).map((item, index) => (
                <Box
                  key={index}
                  textAlign="center"
                  sx={{
                    width: { xs: "50%", md: "25%" }, // ✅ 2 per row on mobile, 4 per row on desktop
                    mb: { xs: 2, md: 0 },
                  }}
                >
                  <Box
                    component="img"
                    src={item.image}
                    alt={item.title}
                    sx={{ mb: 0 }}
                    width="120px"
                    height="120px"
                  />
                  <Typography
                    sx={{
                      fontWeight: 600,
                      color: "#000",
                      fontSize: "1.2rem",
                      mt: { xs: 0, md: -3 },
                      fontFamily: "Inter, sans-serif",
                    }}
                  >
                    {item.title}
                  </Typography>
                </Box>
              ))}
            </Stack>

            <Stack
              direction="row"
              justifyContent="center"
              sx={{ width: "100%", flexWrap: "wrap" }}
              spacing={2}
            >
              {offersData.slice(3).map((item, index) => (
                <Box
                  key={index}
                  textAlign="center"
                  sx={{
                    width: { xs: "50%", md: "25%" }, // ✅ responsive width
                    mb: { xs: 2, md: 0 },
                  }}
                >
                  <Box
                    component="img"
                    src={item.image}
                    alt={item.title}
                    width="120px"
                    height="120px"
                    sx={{ mb: 0 }}
                  />
                  <Typography
                    sx={{
                      fontWeight: 600,
                      color: "#000",
                      fontSize: "1.2rem",
                      mt: { xs: 0, md: -3 },
                      fontFamily: "Inter, sans-serif",
                    }}
                  >
                    {item.title}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </Stack>
        </Container>

        <CareerPopUp open={open} handleClose={handleClose} />
      </Box>
    </>
  );
};

export default CareersPage;
